/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 14:55:14
 * @LastEditors: linxi
 * @LastEditTime: 2021-06-17 20:27:48
 */
import { notification } from "antd"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { Route, Switch } from "react-router-dom"
import "./App.css"
import {
  CREDENTIALS_KEY,
  Logout,
  selectAppError,
  selectApproleType,
  selectLoginState,
} from "./app/appSlice"
import { useAppDispatch } from "./app/hooks"
import { Login } from "./features/login/Login"
import { City } from "./features/Province/City"
import { Country } from "./features/Province/Country"
import { NoAuthority } from "./features/Province/NoAuthority"
import { Province } from "./features/Province/Province"
import { DefaultLayout } from "./layouts/DefaultLayout"
import { useQuery } from "./utils/system"

const App = () => {
  const dispatch = useAppDispatch()

  const isLogin = useSelector(selectLoginState)

  const appError = useSelector(selectAppError)

  const query = useQuery()

  const roleType = useSelector(selectApproleType)
  console.log(roleType)

  useEffect(() => {
    if (appError) {
      notification.error({
        message: appError.message,
        duration: 3,
        placement: "bottomRight",
      })
    }
  }, [appError])

  useEffect(() => {
    const accessToken = query.get("access_token")
    const local = localStorage.getItem(CREDENTIALS_KEY)
    if (accessToken && local) {
      dispatch(Logout(0))
    }
  }, [dispatch, query])
  return isLogin ? (
    <Switch>
      <Route exact path='/'>
        {roleType !== 3 && roleType !== 4 ? (
          <Province />
        ) : roleType === 4 ? (
          <City />
        ) : (
          <Country />
        )}
      </Route>
      <Route path='*'>
        <DefaultLayout />
      </Route>
    </Switch>
  ) : (
    <Login />
  )
}

export default App
